import { Image } from 'components/Image'
import React from 'react'
import isExternalSrcImageUtil from 'components/Image/utils/is-external-src'

/**
 * @param imgMarkdown
 * @param imageIndexRef
 * @return {Element}
 * @constructor
 */
export function ArticleImageMarkdown ({
  imgMarkdown,
  imageIndexRef
}) {
  const srcArr = /src="(.+)\.(jpg|png)"/g.exec(imgMarkdown)
  const src = srcArr
    ? `${srcArr[1]}.${srcArr[2]}`
    : null

  imageIndexRef.current += 1

  const style = {
    maxHeight: '40em',
    maxWidth: '1080px'
  }
  const propsToPass = {
    style,
    className: 'article-contentChunkImage'
  }

  if (
    src &&
    !isExternalSrcImageUtil(src)
  ) {
    const shouldLazyLoad = imageIndexRef.current > 0
    return (
      <div {...propsToPass}>
        <Image
          src={src}
          aspectRatio={Image.ASPECT_RATIO.WIDE_LARGE}
          isHorizontal
          shouldLazyLoad={shouldLazyLoad}
        />
      </div>
    )
  }

  return (
    <div {...propsToPass}>
      <div dangerouslySetInnerHTML={{ __html: imgMarkdown }} />
    </div>
  )
}
